export default (dropdownId, templateId) => ({
    open: false,
    dropdownElement: null,
    dropdownId: dropdownId,
    templateId: templateId,

    init() {
        this.createDropdown();
        this.setupClickOutside();
        this.setupSwiperListener();
    },

    setupSwiperListener() {
        document.querySelectorAll(".swiper").forEach((swiperEl) => {
            if (swiperEl.swiper) {
                swiperEl.swiper.on("slideChange", () => {
                    if (this.open) {
                        this.close();
                    }
                });
            }
        });

        const observer = new MutationObserver(() => {
            document.querySelectorAll(".swiper").forEach((swiperEl) => {
                if (
                    swiperEl.swiper &&
                    !swiperEl.dataset.dropdownListenerAdded
                ) {
                    swiperEl.swiper.on("slideChange", () => {
                        if (this.open) {
                            this.close();
                        }
                    });
                    swiperEl.dataset.dropdownListenerAdded = "true";
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    },

    createDropdown() {
        if (!document.getElementById(this.dropdownId)) {
            const template = document.getElementById(this.templateId);
            if (!template) {
                console.error("Template not found:", this.templateId);
                return;
            }

            const dropdown = document.createElement("div");
            dropdown.id = this.dropdownId;
            dropdown.className =
                "fixed bg-white border border-brandgray-200 shadow-lg rounded-custom z-[9999] transition-all duration-200 ease-out";
            dropdown.style.opacity = "0";
            dropdown.style.transform = "scale(0.95)";
            dropdown.style.pointerEvents = "none";
            dropdown.innerHTML = template.innerHTML;
            dropdown.setAttribute("data-dropdown", "true");
            document.body.appendChild(dropdown);
            this.dropdownElement = dropdown;
        } else {
            this.dropdownElement = document.getElementById(this.dropdownId);
        }
    },

    setupClickOutside() {
        document.addEventListener("click", (e) => {
            if (
                this.open &&
                this.dropdownElement &&
                !this.dropdownElement.contains(e.target) &&
                !this.$refs.dropdownButton.contains(e.target)
            ) {
                this.close();
            }
        });
    },

    updatePosition() {
        const button = this.$refs.dropdownButton;
        const dropdown = this.dropdownElement;
        if (button && dropdown) {
            const rect = button.getBoundingClientRect();
            dropdown.style.top = rect.bottom + "px";
            dropdown.style.left = rect.left + "px";
            dropdown.style.width = rect.width + "px";
        }
    },

    closeAllDropdowns() {
        document
            .querySelectorAll("[data-dropdown=true]")
            .forEach((dropdown) => {
                dropdown.style.opacity = "0";
                dropdown.style.transform = "scale(0.95)";
                dropdown.style.pointerEvents = "none";
            });
    },

    close() {
        this.open = false;
        if (this.dropdownElement) {
            this.dropdownElement.style.opacity = "0";
            this.dropdownElement.style.transform = "scale(0.95)";
            this.dropdownElement.style.pointerEvents = "none";
        }
    },

    toggle() {
        if (!this.open) {
            this.closeAllDropdowns();
        }
        this.open = !this.open;
        if (this.dropdownElement) {
            if (this.open) {
                this.dropdownElement.style.transition = "none";
                this.updatePosition();
                this.$nextTick(() => {
                    this.dropdownElement.style.transition = "all 0.2s ease-out";
                    setTimeout(() => {
                        this.dropdownElement.style.opacity = "1";
                        this.dropdownElement.style.transform = "scale(1)";
                        this.dropdownElement.style.pointerEvents = "auto";
                    }, 10);
                });
            } else {
                this.close();
            }
        }
    },

    destroy() {
        if (this.dropdownElement && this.dropdownElement.parentNode) {
            this.dropdownElement.parentNode.removeChild(this.dropdownElement);
        }
    },
});
